import * as React from "react";

import { Body1 } from "@fluentui/react-components";
import { PersonAccounts24Regular } from "@fluentui/react-icons";

import { useStyles } from "./styles";
import ButtonComponent from "../../../../components/Button/Button";
import { msalService } from "../../../../service/msal.service";

const SignIn: React.FC = () => {
  const styles = useStyles();
  const [loggingIn, setLoggingIn] = React.useState(false);

  const handleLogin = async () => {
    setLoggingIn(true);
    try {
      const result = await msalService.login();
      console.log("[LOGIN] Result:", result);
    } catch (error) {
      console.error("[LOGIN] Error:", error);
    } finally {
      setLoggingIn(false);
    }
  };

  return (
    <div className={styles.container}>
      <Body1 className={styles.message}>Sign in to get started</Body1>
      <ButtonComponent
        variant="primary"
        onClick={handleLogin}
        size="large"
        disabled={loggingIn}
        icon={<PersonAccounts24Regular />}
      >
        {loggingIn ? "Signing in…" : "Sign In"}
      </ButtonComponent>
    </div>
  );
};

export default SignIn;
